// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"9cbf62bd","83":"a2218172","157":"8f73f436","182":"53383c06","191":"6d737dbe","283":"8ea90bfd","427":"a27f7f4a","451":"e6a6e67c","533":"1c1d5a8c","638":"31cd6a67","722":"99e6e714","913":"c518c860"}[chunkId] + ".chunk.js";
};